import type {
  ClientRect,
  Modifier
} from '@dnd-kit/core';
import type {
  Transform
} from '@dnd-kit/utilities';

function restrictToBoundingRect(
  transform: Transform,
  rect: ClientRect,
  boundingRect: ClientRect,
  padding = 0
): Transform {
  const value = {
    ...transform,
  };

  const paddedRect = {
    top: boundingRect.top + padding,
    bottom: boundingRect.bottom - padding,
    left: boundingRect.left + padding,
    right: boundingRect.right - padding,
    width: boundingRect.width - padding * 2,
    height: boundingRect.height - padding * 2,
  };

  if (rect.top + transform.y <= paddedRect.top) {
    value.y = paddedRect.top - rect.top;
  } else if (rect.bottom + transform.y >= paddedRect.bottom) {
    value.y = paddedRect.bottom - rect.bottom;
  }

  if (rect.left + transform.x <= paddedRect.left) {
    value.x = paddedRect.left - rect.left;
  } else if (rect.right + transform.x >= paddedRect.right) {
    value.x = paddedRect.right - rect.right;
  }

  return value;
}

export function restrictToWindowEdgesWithPadding(padding = 0): Modifier {
  return ({transform, draggingNodeRect, windowRect}) => {
    if (!draggingNodeRect || !windowRect) {
      return transform;
    }

    return restrictToBoundingRect(transform, draggingNodeRect, windowRect, padding);
  };
}
